// Copiado do Profit (ctsportal-frontend, src/theme/mui9/AppThemeProvider.js @ 79ed6b10) em 04/11/2026; os repos são separados.
import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@mui/material/styles";
import GlobalStyles from "@mui/material/GlobalStyles";
import AuthContext from "../../connections/auth/AuthProvider";
import createAppTheme from "./createAppTheme";

// A isolacao de classes do v9 (prefixo "pi-") e feita em ./configureClassNames,
// importado como a primeira linha do index.js (precisa rodar antes de qualquer
// componente do @mui/material ser carregado).

const AppThemeProvider = ({ children }) => {
  const { userDetails } = useContext(AuthContext);

  const theme = useMemo(
    () =>
      createAppTheme(
        userDetails?.implementation_color,
        userDetails?.implementation_text_color,
      ),
    [userDetails?.implementation_color, userDetails?.implementation_text_color],
  );

  // Cor do cliente como CSS vars no :root (alcanca tambem portais), para
  // estilos estaticos (styled) — ver CLIENT* em theme/designTokens.js.
  const clientVars = useMemo(() => {
    const custom = theme.palette.custom;
    return {
      ":root": {
        "--pi-client": custom.clientColor,
        "--pi-client-dark": custom.clientColorDark,
        "--pi-client-soft": custom.clientColorLight,
        "--pi-client-tint": custom.clientColorTransparent,
        "--pi-client-text": custom.clientTextColor,
      },
    };
  }, [theme]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={clientVars} />
      {children}
    </ThemeProvider>
  );
};

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppThemeProvider;
